import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16973d72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tftable mt-10",
  border: "1"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "table-header" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "类型"),
    /*#__PURE__*/_createElementVNode("th", null, "基本工资"),
    /*#__PURE__*/_createElementVNode("th", null, "职位津贴"),
    /*#__PURE__*/_createElementVNode("th", null, "年度贡献奖"),
    /*#__PURE__*/_createElementVNode("th", null, "其他补贴"),
    /*#__PURE__*/_createElementVNode("th", null, "公司补助"),
    /*#__PURE__*/_createElementVNode("th", null, "军阶奖"),
    /*#__PURE__*/_createElementVNode("th", null, "考勤总计"),
    /*#__PURE__*/_createElementVNode("th", null, "提成总计"),
    /*#__PURE__*/_createElementVNode("th", null, "福利总计"),
    /*#__PURE__*/_createElementVNode("th", null, "奖金总计"),
    /*#__PURE__*/_createElementVNode("th", null, "一次性奖励总计"),
    /*#__PURE__*/_createElementVNode("th", null, "其他总计"),
    /*#__PURE__*/_createElementVNode("th", null, "应发合计"),
    /*#__PURE__*/_createElementVNode("th", null, "公司医保"),
    /*#__PURE__*/_createElementVNode("th", null, "公司公积金"),
    /*#__PURE__*/_createElementVNode("th", null, "公司养老"),
    /*#__PURE__*/_createElementVNode("th", null, "公司工伤"),
    /*#__PURE__*/_createElementVNode("th", null, "公司生育"),
    /*#__PURE__*/_createElementVNode("th", null, "公司失业"),
    /*#__PURE__*/_createElementVNode("th", null, "公司社保总计")
  ])
], -1))
const _hoisted_3 = { class: "table-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "th--column--1" }, "成本统计", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "th--column--1" }, "发放清单", -1))
const _hoisted_6 = { class: "diffVal th--column--1" }
const _hoisted_7 = { class: "diffVal" }
const _hoisted_8 = { class: "diffVal" }
const _hoisted_9 = { class: "diffVal" }
const _hoisted_10 = { class: "diffVal" }
const _hoisted_11 = { class: "diffVal" }
const _hoisted_12 = { class: "diffVal" }
const _hoisted_13 = { class: "diffVal" }
const _hoisted_14 = { class: "diffVal" }
const _hoisted_15 = { class: "diffVal" }
const _hoisted_16 = { class: "diffVal" }
const _hoisted_17 = { class: "diffVal" }
const _hoisted_18 = { class: "diffVal" }
const _hoisted_19 = { class: "diffVal" }
const _hoisted_20 = { class: "diffVal" }
const _hoisted_21 = { class: "diffVal" }
const _hoisted_22 = { class: "diffVal" }
const _hoisted_23 = { class: "diffVal" }
const _hoisted_24 = { class: "diffVal" }
const _hoisted_25 = { class: "diffVal" }
const _hoisted_26 = { class: "diffVal" }

import { ref, inject, reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import dayjs from 'dayjs'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 校对初始化接口
  'POST/salary/check/cost': fetchList,
} = Api

const viewsLoading: any= inject('viewsLoading')
let fullTableData: any = ref([])
const { MI_modifyForm, MI_height } = new tbMix(fetchList)


const searchConfig = ref([
  {
    type: "TIME",
    label: "交易日期",
    value: dayjs().startOf('year').format('YYYY-MM-DD'),
    upKey: 'month',
    props: {
      'value-format': 'YYYY-MM-DD',
      type: 'year',
      clearable: true,
    }
  },
])

// 搜索处理
const searchHandle = (params: object) => {
  viewsLoading.value = true
  fetchList(params, {timeout: 100000}).then((result) => {
    fullTableData.value = result
  }).finally(() => {
    viewsLoading.value = false
  })
}

const compareDifFg = ref<boolean>(false)
const compareDifTit = ref<string>('')
let compareUserTable = ref([])
const showUserDetails = (month: any, index: number) => {
  personalData.value = []
  compareUserTable.value = month.data
  compareDifTit.value = index + 1 + '月对比差异'

  compareDifFg.value = true
}





// 点击用户展示详情
let personalData: any = ref([])
let currentDisplayUser: any = reactive({})
const showDetails = (row: any) => {
  // costVo成本统计，salaryVo发放清单
  personalData.value = [row.costVo, row.salaryVo]
  Object.assign(currentDisplayUser, row)
  ElMessage('已选择')
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "薪酬校验-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "table-container",
      style: _normalizeStyle({ height: _unref(MI_height) + 80 + 'px' })
    }, [
      _createElementVNode("table", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("tbody", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fullTableData), (_month, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createElementVNode("tr", null, [
                _hoisted_4,
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumSalary)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumJobAllowance)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumPostAllowance)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumOtherAllowance)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyAllowance)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumRankAllowance)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumAttendance.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCommission.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumWelfare.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumBonus.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumOneTimeReward.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumOther.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumTotalSalary)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyMedical)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyHousing)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyEndowment)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyInjury)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyMaternity)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyUnemployment)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanySocialSecurity)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_5,
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumSalary)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumJobAllowance)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumPostAllowance)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumOtherAllowance)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumCompanyAllowance)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumRankAllowance)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumAttendance.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumCommission.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumWelfare.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumBonus.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumOneTimeReward.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumOther.totalAmount)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumTotalSalary)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumCompanyMedical)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumCompanyHousing)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumCompanyEndowment)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumCompanyInjury)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumCompanyMaternity)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumCompanyUnemployment)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getNumber)(_month.salarySumVo.sumCompanySocialSecurity)), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(_component_el_link, {
                    type: "primary",
                    onClick: ($event: any) => (showUserDetails(_month, index))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(index + 1) + "月差异 ", 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumSalary - _month.salarySumVo.sumSalary )), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumJobAllowance - _month.salarySumVo.sumJobAllowance )), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumPostAllowance - _month.salarySumVo.sumPostAllowance )), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumOtherAllowance - _month.salarySumVo.sumOtherAllowance )), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyAllowance - _month.salarySumVo.sumCompanyAllowance )), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumRankAllowance - _month.salarySumVo.sumRankAllowance )), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumAttendance.totalAmount - _month.salarySumVo.sumAttendance.totalAmount )), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCommission.totalAmount - _month.salarySumVo.sumCommission.totalAmount )), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumWelfare.totalAmount - _month.salarySumVo.sumWelfare.totalAmount )), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumBonus.totalAmount - _month.salarySumVo.sumBonus.totalAmount )), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumOneTimeReward.totalAmount - _month.salarySumVo.sumOneTimeReward.totalAmount )), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumOther.totalAmount - _month.salarySumVo.sumOther.totalAmount )), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumTotalSalary - _month.salarySumVo.sumTotalSalary )), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyMedical - _month.salarySumVo.sumCompanyMedical)), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyHousing - _month.salarySumVo.sumCompanyHousing)), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyEndowment - _month.salarySumVo.sumCompanyEndowment)), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyInjury - _month.salarySumVo.sumCompanyInjury)), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyMaternity - _month.salarySumVo.sumCompanyMaternity)), 1),
                _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanyUnemployment - _month.salarySumVo.sumCompanyUnemployment)), 1),
                _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(getNumber)(_month.costSumVo.sumCompanySocialSecurity - _month.salarySumVo.sumCompanySocialSecurity)), 1)
              ])
            ], 64))
          }), 128))
        ])
      ])
    ], 4),
    _createVNode(_component_el_dialog, {
      width: "92%",
      modelValue: compareDifFg.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compareDifFg).value = $event)),
      title: compareDifTit.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  ref: "tb",
                  border: "",
                  data: _unref(compareUserTable),
                  "max-height": _unref(MI_height) - 150 + 'px'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "员工",
                      prop: "userName",
                      "show-overflow-tooltip": ""
                    }, {
                      default: _withCtx(({ row }) => [
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (showDetails(row)),
                          type: row.equal === false  ? 'danger' : 'primary'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.userName + ' (' + row.alias + ')'), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "type"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data", "max-height"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 19 }, {
              default: _withCtx(() => [
                (_unref(currentDisplayUser).userName)
                  ? (_openBlock(), _createBlock(_component_el_descriptions, {
                      key: 0,
                      column: "1",
                      border: "",
                      class: "mb-10"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_descriptions_item, { label: "当前查看" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tag, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(currentDisplayUser).userName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "原因" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(currentDisplayUser).remarks), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table, {
                  data: _unref(personalData),
                  border: "",
                  "max-height": _unref(MI_height) - 150 + 'px'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "类型",
                      width: "100",
                      formatter: (row, column, cellValue, index) => index === 0 ? '成本统计' : '发放清单'
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "基本工资",
                      prop: "salary",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "职位津贴",
                      prop: "jobAllowance",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "年度贡献奖",
                      prop: "postAllowance",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "其他补贴",
                      prop: "otherAllowance",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司补助",
                      prop: "companyAllowance",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "军阶奖",
                      prop: "rankAllowance",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "考勤",
                      prop: "attendance.totalAmount"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "奖金",
                      prop: "bonus.totalAmount"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "提成",
                      prop: "commission.totalAmount"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "福利",
                      prop: "welfare.totalAmount"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "一次性奖励",
                      prop: "oneTimeReward.totalAmount"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "其他",
                      prop: "other.totalAmount"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "其他扣款",
                      prop: "otherDeduction.totalAmount"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "应发合计",
                      prop: "totalSalary",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司医保",
                      prop: "companyMedical",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司公积金",
                      prop: "companyHousing",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司养老",
                      prop: "companyEndowment",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司工伤",
                      prop: "companyInjury",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司生育",
                      prop: "companyMaternity",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司失业",
                      prop: "companyUnemployment",
                      width: "100"
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司社保总计",
                      prop: "companySocialSecurity",
                      width: "100"
                    }, null, 8, ["formatter"])
                  ]),
                  _: 1
                }, 8, ["data", "max-height"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ])), [
    [_directive_loading, false]
  ])
}
}

})